module.exports = __webpack_public_path__ + "c_static/img/9查看评价.49791f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/9查看评价.jpg
// module id = d6OD
// module chunks = 33